import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { HYDRA_6PM_ADSENSE } from 'constants/hydraTests';
import { isAssigned, isInAssignment, triggerAssignment } from 'actions/ab';

export class AdsenseSlot extends Component {
  static contextTypes = {
    marketplace: PropTypes.object
  };

  static propTypes = {
    name: PropTypes.string.isRequired,
    adId: PropTypes.string.isRequired
  };

  componentDidMount() {
    if (isInAssignment(triggerAssignment(HYDRA_6PM_ADSENSE))) {
      this.fetchAdsenseAds();
    }
  }

  componentDidUpdate(prevProps) {
    const { prevHoneTag, prevPage } = prevProps;
    const { honeTag, page, hydra6pmAdsense } = this.props;

    if (hydra6pmAdsense) {
      if (prevHoneTag !== honeTag || prevPage !== page) {
        this.fetchAdsenseAds();
      }
    }
  }

  fetchAdsenseAds = () => {
    const { marketplace } = this.context;
    const { ads : { adsenseId } = {} } = marketplace;

    const {
      name,
      adId,
      page = 1,
      honeTag,
      googleAdsConfig
    } = this.props;

    // dont attempt to render ads when search term isn't defined or empty
    if (!honeTag) {
      return null;
    }

    const adConfig = {
      pubId: `pub-${adsenseId}`,
      styleId: adId,
      query: honeTag,
      adsafe: 'high',
      adPage: page + 1, // page offset by one
      ...googleAdsConfig
    };

    const adStyleConfig = {
      container: name,
      number: 1
    };

    // make sure we don't 500 the page if google adsense doesnt work
    try {
      window._googCsa('ads', adConfig, adStyleConfig);
    } catch (e) { /* dont do anything */ }
  };

  render() {
    const { name, className } = this.props;

    return (
      <div id={name} className={className} />
    );
  }
}

export const mapStateToProps = state => {
  const { googleAdsConfig } = state.environmentConfig;
  const { honeTag, page } = state.filters;

  return {
    googleAdsConfig,
    honeTag,
    page,
    hydra6pmAdsense: isAssigned(HYDRA_6PM_ADSENSE, 1, state)
  };
};

export default connect(mapStateToProps, {
  triggerAssignment
})(AdsenseSlot);
